module.exports = __webpack_public_path__ + "bb3b459487a0628bcc0178c76c4ec7c7.svg";